import { Box, Divider, Drawer, FormControlLabel, Radio, RadioGroup, Toolbar, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../components/ui/IconButton';
import { ThemeMode } from '../context/ThemeContext';
import { useTheme } from '../hooks/useTheme'; // ton hook thème
import { capitalizeFirstLetter } from '../utils/capitalize';

interface SettingsPanelProps {
    open: boolean;
    onClose: () => void;
}

const SettingsPanel: React.FC<SettingsPanelProps> = ({ open, onClose }) => {
    const { mode, toggleTheme, setThemeMode, muiTheme } = useTheme();
    const { i18n, t } = useTranslation();

    const handleLangChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

    return (
        <Drawer
            variant={isMobile ? 'temporary' : 'permanent'}
            open={isMobile ? open : true}
            onClose={onClose}
            anchor="right"
            ModalProps={{ keepMounted: true }}
            sx={{
                width: open || isMobile ? '240px' : '0px',
                transition: muiTheme.transitions.create('width', {
                    easing: muiTheme.transitions.easing.sharp,
                    duration: muiTheme.transitions.duration.enteringScreen,
                }),
                flexShrink: 0,
                position: 'sticky',

                '& .MuiDrawer-paper': {
                    width: open || isMobile ? '240px' : '0px',
                    transition: muiTheme.transitions.create('width', {
                        easing: muiTheme.transitions.easing.sharp,
                        duration: muiTheme.transitions.duration.enteringScreen,
                    }),
                    overflowX: 'hidden',
                    boxSizing: 'border-box',
                    border: 0,
                    backgroundColor: isMobile ? undefined : '#000',
                },
            }}
        >
            {!isMobile && <Toolbar />}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    gap: 2,
                    padding: 1,
                    borderRadius: 2,
                    backgroundColor: isMobile ? undefined : muiTheme.palette.background.paper,
                    marginRight: '10px',
                    marginBottom: '10px',
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{capitalizeFirstLetter(t('settings'))}</Typography>
                    <IconButton iconName="close" onClick={onClose} />
                </Box>

                <Divider />
                <Box>
                    <Typography variant="subtitle1">{capitalizeFirstLetter(t('theme'))}</Typography>

                    <RadioGroup value={mode} onChange={(e, value) => setThemeMode(value as ThemeMode)}>
                        <FormControlLabel value="dark" control={<Radio />} label={capitalizeFirstLetter(t('dark'))} />
                        <FormControlLabel value="light" control={<Radio />} label={capitalizeFirstLetter(t('light'))} />
                    </RadioGroup>
                </Box>
                <Divider />
                <Box>
                    <Typography variant="subtitle1">{capitalizeFirstLetter(t('language'))}</Typography>
                    <RadioGroup value={i18n.language} onChange={handleLangChange}>
                        <FormControlLabel value="fr" control={<Radio />} label="Français" />
                        <FormControlLabel value="en" control={<Radio />} label="English" disabled />
                    </RadioGroup>
                </Box>
            </Box>
        </Drawer>
    );
};

export default SettingsPanel;
